// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LayersThreeADefault } from '../../../assets/icons/default/layout/layers-three-a.svg?react';
import { ReactComponent as LayersThreeASolid } from '../../../assets/icons/solid/layout/LAYERS-THREE-A.svg?react';
import { createIcons } from '../../Icon';
const LayersThreeAIcon = /* @__PURE__ */ createIcons('LayersThreeA', {
    default: LayersThreeADefault,
    solid: LayersThreeASolid
});
LayersThreeAIcon.supportedTypes = ['default', 'solid'];
LayersThreeAIcon.category = 'layout';
export default LayersThreeAIcon;
